import { CALL_TYPE_ID, DEAL_TYPE_ID, EMAIL_TYPE_ID, MEETING_EVENT_TYPE_ID, NOTE_TYPE_ID, TASK_TYPE_ID, TICKET_TYPE_ID, QUOTE_TYPE_ID, LINE_ITEM_TYPE_ID, LEAD_TYPE_ID, SERVICE_TYPE_ID, SUBSCRIPTION_TYPE_ID, CART_TYPE_ID, MARKETING_EVENT_TYPE_ID, COURSE_TYPE_ID, LISTING_TYPE_ID, APPOINTMENT_TYPE_ID, POSTAL_MAIL_TYPE_ID, COMMUNICATION_TYPE_ID, CAMPAIGN_TYPE_ID, CONTRACT_TYPE_ID, CREDIT_MEMO_TYPE_ID, COMMERCE_PAYMENT_TYPE_ID, PAYMENT_LINK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { AppointmentIcon, CallingIcon, CartIcon, CaseIcon, CourseIcon, CustomObjectIcon, DealsIcon, DescriptionIcon, EmailIcon, MarketingEventsIcon, MeetingsIcon, PaymentSubscriptionsIcon, RealEstateListingIcon, RotateLeadsIcon, SalesQuoteIcon, SmsIcon, SocialBlockLinkedinIcon, SocialWhatsappIcon, TagIcon, TasksIcon, TicketIcon, CampaignsIcon, FileIcon, CreditCardIcon, LinkIcon, InvoiceIcon } from 'foundations-assets';
const SMS_ID = `${COMMUNICATION_TYPE_ID}_SMS`;
const LINKEDIN_MESSAGE_ID = `${COMMUNICATION_TYPE_ID}_LinkedIn Messages`;
const WHATSAPP_MESSAGE_ID = `${COMMUNICATION_TYPE_ID}_WhatsApp Messages`;
export const getObjectTypeIcon = ({
  objectTypeId
}) => {
  if (objectTypeId !== null && objectTypeId !== void 0 && objectTypeId.startsWith('2-')) {
    return CustomObjectIcon;
  }
  switch (objectTypeId) {
    case DEAL_TYPE_ID:
      return DealsIcon;
    case TICKET_TYPE_ID:
      return TicketIcon;
    case LEAD_TYPE_ID:
      return RotateLeadsIcon;
    case LINE_ITEM_TYPE_ID:
      return TagIcon;
    case QUOTE_TYPE_ID:
      return SalesQuoteIcon;
    case EMAIL_TYPE_ID:
    case POSTAL_MAIL_TYPE_ID:
      return EmailIcon;
    case MEETING_EVENT_TYPE_ID:
      return MeetingsIcon;
    case NOTE_TYPE_ID:
      return DescriptionIcon;
    case TASK_TYPE_ID:
      return TasksIcon;
    case CALL_TYPE_ID:
      return CallingIcon;
    case SUBSCRIPTION_TYPE_ID:
      return PaymentSubscriptionsIcon;
    case MARKETING_EVENT_TYPE_ID:
      return MarketingEventsIcon;
    case CART_TYPE_ID:
      return CartIcon;
    case COURSE_TYPE_ID:
      return CourseIcon;
    case LISTING_TYPE_ID:
      return RealEstateListingIcon;
    case APPOINTMENT_TYPE_ID:
      return AppointmentIcon;
    case SERVICE_TYPE_ID:
      return CaseIcon;
    case CAMPAIGN_TYPE_ID:
      return CampaignsIcon;
    case CONTRACT_TYPE_ID:
      return FileIcon;
    case COMMERCE_PAYMENT_TYPE_ID:
      return CreditCardIcon;
    case PAYMENT_LINK_TYPE_ID:
      return LinkIcon;
    case CREDIT_MEMO_TYPE_ID:
      return InvoiceIcon;
    case SMS_ID:
      return SmsIcon;
    case LINKEDIN_MESSAGE_ID:
      return SocialBlockLinkedinIcon;
    case WHATSAPP_MESSAGE_ID:
      return SocialWhatsappIcon;
    default:
      return null;
  }
};